import React, { useState, useEffect } from 'react';
import { INDEX_URL, CUST, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import { fixDate, translateLanguages } from '../../helpers/helperFunctions';
import Button from '../Buttons/Button';
import BillingModal from '../Modals/BillingModal';
import toast from 'react-hot-toast';
import { name } from 'dayjs/locale/sv';
import ApiAccessModal from '../Modals/ApiAccessModal';

const ApiAccess = ({}) => {
	const { t } = useTranslation();
    const [apiInfo, setApiInfo] = useState()
    const [showModal, setShowModal] = useState(false)
    const [type, setType] = useState()
    const [docUrl, setDocUrl] = useState()
    const [items, setItems] = useState([
        {
            name: "requests",
            data: "",
            extra: t("settings.resets_24")
        },
        {
            name: "key",
            icon: icons.dots_vertical,
            data: "",
            function: () => openModal("key")
        },
        {
            name: "documentation",
            icon: icons.chevron_right,
            function: () => openURL()
        }
    ])

    useEffect(() => {
        checkStatus()
    }, [])

    const checkStatus = () => {
        const data = {action: "status"}
        request.postUnique("", "publicapi/v1/user/apitoken", data).then((response) => {
            if(!response.data.error){
                const limit = response?.data?.data?.daily_limit
                const count = response?.data?.data?.request_count
                const token = response?.data?.data?.token
                setApiInfo(response?.data?.data)
                setDocUrl(response?.data?.data?.doc_url)
                setItems(prevItems =>
                    prevItems.map(item => {
                        if (item.name === "requests") {
                            return {
                                ...item,
                                data: t("settings.api_limit", { val1: count, val2: limit }),
                            };
                        }
                        if (item.name === "key") {
                            return {
                                ...item,
                                data: "••••••••••••",
                            };
                        }
                        if (item.name === "documentation") {
                            return {
                                ...item,
                                function: () => {
                                    if (response?.data?.data?.doc_url) {
                                        window.open(response.data.data.doc_url, "_blank");
                                    } else {
                                        toast.error("ERROR");
                                    }
                                },
                            };
                        }
                        return item;
                    })
                );
            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }

        })
    }

    const openModal = (type) => {
        setType(type)
        setShowModal(!showModal)
    }

    const openURL = () => {
        if(docUrl){
            window.open(docUrl, "_blank");
        }else{
            toast.error("ERROR")
        }
    }

    const saveData = (data) => {
        request.postUnique("", "publicapi/user/apitoken", data).then((response) => {
            if (response.data) {
                const toke = response?.data?.data?.token
                setApiInfo(prev => ({
                    ...prev,
                    token: toke
                }));
                checkStatus()
                toast.success(t("toast.saved"));
            }else{
                const msg = response?.data?.message
                toast.error(msg ?? t("toast.error"))
            }
        })
    }

    return(
        <>
        <p className="mb-1 bold">{t("settings.api_access")}</p>
        <div className="d-flex flex-column primary settings-radius mb-3">
            <div className={`p-3 d-flex justify-content-between align-items-center bg-white`}>
                <h4 className="regular">{t("settings.api")}</h4>
                <div className="form-check form-switch">
                    <input className="form-check-input" onClick={() => saveData({action: apiInfo.activated ? "deactivate" : "activate"})} type="checkbox" role="switch" id="flexSwitchCheckDefault" defaultChecked={apiInfo && apiInfo.activated} />
                </div>
            </div>
        </div>
        <div className={`d-flex flex-column settings-radius primary ${!apiInfo?.activated ? "d-none" : ""}`}>
            {items.map((item, index) => (
                <div 
                key={index} 
                className={`p-3 d-flex justify-content-between bg-white ${index < items.length-1 ? "border-settings" : ""} ${item.icon ? "cursor-pointer" : ""}`} onClick={item.function}>
                    <h4 className="regular align-self-center">{t(`settings.${item.name}`)}</h4>
                    <div className={`d-flex flex-${item.extra ? "column" : "row"} align-items-center `}> 
                        <p className="m-0 p-0">{item.data}</p>
                        {item.extra && <p className="m-0 p-0 dark_grey">{`(${item.extra})`}</p>}
                        {item.icon &&
                            <img className="ms-3 size_15 grey-blue-icon" src={item.icon} alt={""} />
                        }
                    </div>
                </div>
            ))}
        </div>
        <ApiAccessModal show={showModal} type={type} data={apiInfo} onSave={(data) => saveData(data)} onClose={() => setShowModal(!showModal)}/>
        </>
    )
}

export default ApiAccess;